'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _component = require('react-pure-render/component');

var _component2 = _interopRequireDefault(_component);

var _icon = require('../icon');

var _icon2 = _interopRequireDefault(_icon);

var _paperMenu = require('../paper-menu');

var _paperMenu2 = _interopRequireDefault(_paperMenu);

var _checkbox = require('../checkbox');

var _checkbox2 = _interopRequireDefault(_checkbox);

var _layout = require('../layout');

var _button = require('../button');

var _button2 = _interopRequireDefault(_button);

var _buttonDropdown = require('./button-dropdown.css');

var _buttonDropdown2 = _interopRequireDefault(_buttonDropdown);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ButtonDropdown = function (_PureComponent) {
  (0, _inherits3.default)(ButtonDropdown, _PureComponent);

  function ButtonDropdown(props) {
    (0, _classCallCheck3.default)(this, ButtonDropdown);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ButtonDropdown.__proto__ || Object.getPrototypeOf(ButtonDropdown)).call(this, props));

    _this.state = {
      open: false
    };

    _this.onToggle = _this.onToggle.bind(_this);
    _this.wrapperRef = _this.onToggle.bind(_this);
    _this.onClose = _this.onClose.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(ButtonDropdown, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('click', this.onClose);
    }
  }, {
    key: 'open',
    value: function open() {
      var _this2 = this;

      setTimeout(function () {
        return window.addEventListener('click', _this2.onClose);
      }, 300);
      this.setState({ open: true });
    }
  }, {
    key: 'close',
    value: function close() {
      window.removeEventListener('click', this.onClose);
      this.setState({ open: false });
    }
  }, {
    key: 'onToggle',
    value: function onToggle() {
      if (this.state.open) {
        this.close();
      } else {
        this.open();
      }
    }
  }, {
    key: 'onClose',
    value: function onClose() {
      this.close();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          children = _props.children,
          disabled = _props.disabled,
          _props$selectItems = _props.selectItems,
          selectItems = _props$selectItems === undefined ? [] : _props$selectItems,
          checkboxProps = _props.checkboxProps,
          otherProps = (0, _objectWithoutProperties3.default)(_props, ['children', 'disabled', 'selectItems', 'checkboxProps']);


      return React.createElement(
        _button2.default,
        (0, _extends3.default)({
          active: this.state.open,
          onClick: !disabled ? this.onToggle : null,
          disabled: disabled
        }, otherProps),
        checkboxProps ? React.createElement(_checkbox2.default, (0, _extends3.default)({ size: 'large', disabled: disabled }, checkboxProps)) : null,
        children ? React.createElement(
          _layout.Box,
          { marginLeft: checkboxProps ? 12 : 0 },
          children
        ) : null,
        selectItems.length ? React.createElement(
          _icon2.default,
          { marginLeft: 8, marginRight: -8, size: 20 },
          'keyboard_arrow_down'
        ) : null,
        selectItems.length ? React.createElement(
          'div',
          { className: _buttonDropdown2.default.menu },
          React.createElement(
            _paperMenu2.default,
            { open: this.state.open, origin: 'top', width: '100%' },
            selectItems.map(function (item) {
              return React.createElement(
                _paperMenu.PaperMenuItem,
                (0, _extends3.default)({
                  disabled: item.disabled,
                  key: item.title,
                  component: item.component,
                  minWidth: item.minWidth
                }, item.componentProps, {
                  onClick: !item.disabled ? function () {
                    if (item.onClick) item.onClick();
                    _this3.onToggle();
                  } : null
                }),
                item.title
              );
            })
          )
        ) : null
      );
    }
  }]);
  return ButtonDropdown;
}(_component2.default);

exports.default = ButtonDropdown;


//////////////////
// WEBPACK FOOTER
// ./~/@kalo/ui/lib/components/button-dropdown/button-dropdown.js
// module id = 306
// module chunks = 114276838955818